import React from 'react';
import { StarIcon } from 'lucide-react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
interface HeroSectionProps {
  onCtaClick: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="py-12 md:py-24 px-5 max-w-6xl mx-auto pt-[20px] pb-[20px]" data-id="element-43">
      <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-44">
        <div className="flex-1 space-y-8" data-id="element-45">
          <FadeInUp data-id="element-46">
            <span className="inline-block bg-zen-beige text-slate-dark text-sm font-semibold px-4 py-1.5 rounded-full" data-id="element-47">
              SISTEMA DE CALMA RESPALDADO POR ETÓLOGOS CANINOS 🐾
            </span>
          </FadeInUp>

          <FadeInUp delay={0.1} data-id="element-48">
            <h1 className="text-4xl md:text-6xl font-serif font-bold leading-tight text-[#1D1D1F]" data-id="element-49">
              De Caos a <span className="text-[#86EFAC]" data-id="element-50">Calma</span> en solo 7 minutos al día
            </h1>
          </FadeInUp>

          <FadeInUp delay={0.2} data-id="element-51">
            <p className="text-lg md:text-xl text-slate-dark/80 font-sans leading-relaxed" data-id="element-52">
              El primer protocolo interactivo de psicología canina diseñado para
              dueños en departamento. Sin castigos, solo ciencia.
            </p>
          </FadeInUp>

          <FadeInUp delay={0.3} data-id="element-53">
            <div className="flex items-center gap-3" data-id="element-54">
              <div className="flex text-yellow-400" data-id="element-55">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-56" />)}
              </div>
              <span className="text-sm font-medium text-slate-dark/70" data-id="element-57">
                +1,200 dueños felices en Chile
              </span>
            </div>
          </FadeInUp>

          <FadeInUp delay={0.4} data-id="element-58">
            <ShimmerButton onClick={onCtaClick} className="w-full sm:w-auto text-lg" data-id="element-59">
              ¡Sí, Quiero Un Perro Tranquilo! - $4.990
            </ShimmerButton>
          </FadeInUp>
        </div>

        <div className="flex-1 w-full" data-id="element-60">
          <FadeInUp delay={0.2} className="relative aspect-[4/5] w-full max-w-md mx-auto" data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/vEJPcjkGj9kf8sva5bDKmh/PortadaProducto.png" alt="Mascota Genial Protocolo de Calma" className="object-cover w-full h-full rounded-3xl shadow-2xl" fetchPriority="high" data-id="element-62" />
          </FadeInUp>
        </div>
      </div>
    </section>;
}